import DateInput from "@/components/Common/DateInput/DateInput.vue";
import TimeInput from "@/components/Common/TimeInput/TimeInput.vue";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import { snowTextureItems } from "@/configuration/formConfigurations";

export default {
  components: { DateInput, TimeInput, InfoDialog },
  props: ["editedItem", "isOwnedBySubPrincipal"],
  data: () => ({
    stateItems: [
      { id: "", title: "Keine Angabe" },
      { id: "open", title: "Geöffnet" },
      { id: "closed", title: "Geschlossen" },
      { id: "seasonEnd", title: "Ende der Saison" },
      { id: "openingHours", title: "Gemäß Öffnungszeiten" },
      { id: "dependingOnLifts", title: "Abhängig Liftöffnung" }
    ],
    snowTextureItems,
    avalancheItems: [
      { id: "low", title: "1 Gering" },
      { id: "moderate", title: "2 Mäßig" },
      { id: "considerable", title: "3 Erheblich" },
      { id: "high", title: "4 Groß" },
      { id: "veryHigh", title: "5 Sehr Groß" }
    ],
    weatherConditionItems: [
      { id: "bright", title: "Heiter" },
      { id: "slightlyCloudy", title: "Leicht bewölkt" },
      { id: "cloudy", title: "Bewölkt" },
      { id: "foggy", title: "Nebelig" },
      { id: "drizzle", title: "Nieselregen" },
      { id: "shudder", title: "Schauer" },
      { id: "rain", title: "Regen" },
      { id: "snowfall", title: "Schneefall" },
      { id: "lightSnow", title: "Leichter Schneefall" },
      { id: "sleet", title: "Schneeregen" },
      { id: "blizzard", title: "Schneesturm" },
      { id: "cloudless", title: "Wolkenlos" }
    ],
    sightItems: [
      { id: "goodVision", title: "Gute Fernsicht" },
      { id: "foggy", title: "Nebelig" }
    ]
  }),
  inject: ["sharedState"],
  mounted() {
    this.sharedState.stateItems = this.stateItems;
  }
};
